export const GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH = '64px';
export const GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH = '236px';
export const GLOBAL_NAVIGATION_SIDEBAR_WIDTH = `var(--global-nav-vertical-nav-width, ${GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH})`;
export const GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT = '44px';
export const GLOBAL_NAVIGATION_TOOLBAR_HEIGHT = `var(--global-nav-height, ${GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT})`;
export const BREAKPOINT_SMALL = '544px';
export const BREAKPOINT_MEDIUM = '768px';
export const BREAKPOINT_LARGE = '992px';
export const BREAKPOINT_EXTRA_LARGE = '1200px';